import cx from 'classnames'
import styles from './ProgressBar.module.css'

interface BarProps {
  progress: number
  style?: 'striped'
}

interface ProgressBarProps {
  bars: BarProps[]
}

/**
 * A horizontal bar with one or more stacked progress segments.
 */
export function ProgressBar({ bars }: ProgressBarProps) {
  return (
    <div className={styles.progress} data-slot="progress-bar">
      {bars.map((bar, index) => (
        <div
          key={index}
          className={cx(
            styles.progressBar,
            bar.style === 'striped' && styles.progressBarStriped,
          )}
          style={{ width: `${bar.progress}%` }}
        />
      ))}
    </div>
  )
}
